import React from 'react';
import { Box, Grid, CardContent, Card } from '@mui/material';
import PropTypes from 'prop-types';
import { TIPO_USUARIO as tipoUsuario } from '../../../../consts/tipoUsuario';

export default function SeccionPreviewPaciente({ pacienteSeleccionado, idTipoUsuario }) {
    function ItemR(props) {
        const { sx, ...other } = props;
        return (
            <Box
                sx={{
                    bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                    color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
                    borderRadius: 0,
                    fontSize: '0.75rem',
                    ...sx,
                    padding: 1
                }}
                {...other}
            />
        );
    }

    ItemR.propTypes = {
        sx: PropTypes.oneOfType([
            PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
            ),
            PropTypes.func,
            PropTypes.object,
        ]),
    };

    return (
        <>
            {pacienteSeleccionado.idPaciente > 0 && idTipoUsuario == tipoUsuario.PACIENTE &&
                <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
                    <CardContent>
                        <div style={{ fontSize: '10pt', backgroundColor: '#0072BA', color: 'white', width: '100%', textAlign: 'center', padding: 5 }}>
                            Paciente
                        </div>
                        <Grid container spacing={0.5}>
 <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                                <ItemR>
                                    <strong>{pacienteSeleccionado.apellido} {pacienteSeleccionado.nombre} - {pacienteSeleccionado.tipoDocumento} {pacienteSeleccionado.numeroDocumento} - ID {pacienteSeleccionado.idPaciente}</strong>
                                </ItemR>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            }
        </>
    )

};